import moment from "moment";
import { setStorageData } from "@/utils/storage";

const saveTimeToken = tokenExpiration => {
  const expireTime = moment()
    .add(tokenExpiration, "seconds")
    .toString();

  return setStorageData("timeToExpire", { expireTime });
};

export default saveTimeToken;
